/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFeedbackSubmissionCreationRequest
 */
export interface APIFeedbackSubmissionCreationRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof APIFeedbackSubmissionCreationRequest
     */
    submission: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackSubmissionCreationRequest
     */
    article: string;
}

/**
 * Check if a given object implements the APIFeedbackSubmissionCreationRequest interface.
 */
export function instanceOfAPIFeedbackSubmissionCreationRequest(value: object): value is APIFeedbackSubmissionCreationRequest {
    if (!('submission' in value) || value['submission'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    return true;
}

export function APIFeedbackSubmissionCreationRequestFromJSON(json: any): APIFeedbackSubmissionCreationRequest {
    return APIFeedbackSubmissionCreationRequestFromJSONTyped(json, false);
}

export function APIFeedbackSubmissionCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackSubmissionCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission': json['submission'],
        'article': json['article'],
    };
}

export function APIFeedbackSubmissionCreationRequestToJSON(value?: APIFeedbackSubmissionCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'submission': value['submission'],
        'article': value['article'],
    };
}

